export default [
  {
    path: '*',
    name: 'notFound',
    // component: () => import('@/outlets/error-outlet'), // TODO
  },
  {
    path: '/error',
    name: 'error',
    // component: () => import('@/outlets/error-outlet'), // TODO
  },
  {
    path: '/',
    component: () => import('@/pages/Main'),
    children: [
      {
        path: '/',
        name: 'home',
        meta: {
          title: 'Profunda Physiotherapie in Würzburg',
        },
        component: () => import('@/pages/home/Home'),
        children: [
          {
            path: '/#:target',
            name: 'home-sub',
            meta: {
              title: 'Profunda Physiotherapie in Würzburg',
            },
          }
        ],
      },
      {
        path: 'impressum',
        name: 'impressum',
        meta: {
          title: 'Impressum | Profunda Physiotherapie in Würzburg',
        },
        component: () => import('@/pages/imprint/Imprint'),
      },
      {
        path: 'datenschutz',
        name: 'datenschutz',
        meta: {
          title: 'Datenschutz | Profunda Physiotherapie in Würzburg',
        },
        component: () => import('@/pages/privacy/Privacy'),
      },
    ],
  },
];
